import React from "react";
import "./login.scss";
import logo from "../../assets/BankeMainLogo.png";
import loginImage from "../../assets/login.png";
import { useState, useContext } from "react";
import { SetAllContext } from "../../services/AllContext.js";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import http from "../../services/http-commons.js";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
  const navigate = useNavigate();
  // ================ Contexts ================
  const { setAuthToken, serUserID, setUserName } = useContext(SetAllContext);
  // ================ useState =================
  const [loginCred, setLoginCred] = useState({ username: "", password: "" });
  const [resetPassword, setResetPassword] = useState("");
  const [otpSent, setOTPSent] = useState(false);
  const [resetNewPassword, setresetNewPassword] = useState("");
  const [resetOTP, setResetOTP] = useState("");

  // ============ Functions =============
  // Login with Google function
  async function handleGoogleSuccess(credentialResponse) {
    try {
      const response = await http.USERHTTP.post("/auth/google", {
        id_token: credentialResponse.credential,
      });

      setAuthToken(response.data.access_token);
      serUserID(response.data.user_details.id);
      setUserName(response.data.user_details.firstname);

      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Google login failed", {
        autoClose: 3000,
      });

      console.log("Google login error", error);
    }
  }
  // =======RESET FUNCTIONS==========
  // =========CONFIRM USER'S EMAIL FIRST AND TRIGGER AN OTP FOR USER==============
  function confirmEmail() {
    let emailConfirmationBody = {
      user_email: resetPassword,
      email_channel: "email",
    };
    const resetPawordEmailConfirmation = http.USERHTTP.post(
      `/send-otp`,
      emailConfirmationBody,
    );

    toast.promise(
      resetPawordEmailConfirmation,
      {
        pending: "Confirming email...",
        success: `OTP sent to ${resetPassword}! 🎉`,
        error: "OTP failed to send 😞",
      },
      {
        autoClose: 3000,
      },
    );
    resetPawordEmailConfirmation
      .then(() => {
        setOTPSent(true);
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          },
        );
        console.log("OTP Generation error", error);
      });
  }

  //  ============NOW RESET PASSWORD========
  function resetUsersPassowrd() {
    let resetPasswordBody = {
      email: resetPassword,
      otp: resetOTP,
      password: resetNewPassword,
    };
    const newPasswordReset = http.USERHTTP.post(
      `/reset-password`,
      resetPasswordBody,
    );

    toast.promise(
      newPasswordReset,
      {
        pending: "Resetting Password...",
        success: `Password reset successful! 🎉`,
        error: "Failed to reset password 😞",
      },
      {
        autoClose: 3000,
      },
    );
    newPasswordReset
      .then(() => {
        setOTPSent(false);
        window.location.reload();
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          },
        );
        console.log("Failed to reset password", error);
      });
  }

  // ========= USER PROPER LOG-IN ==========
  function handleChange(e) {
    const { name, value } = e.target;
    setLoginCred({ ...loginCred, [name]: value });
  }

  function logUserIn() {
    const loginPromise = http.USERHTTP.post(`/login`, loginCred);

    toast.promise(
      loginPromise,
      {
        pending: "Logging in...",
        success: "Login successful! 🎉",
        error: "Unable to log in 😞",
      },
      {
        autoClose: 3000,
      },
    );
    loginPromise
      .then((response) => {
        setAuthToken(response.data.access_token);
        serUserID(response.data.user_details.id);
        setUserName(response.data.user_details.firstname);
        navigate("/");
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          },
        );
        console.log("Log-In error", error);
      });
  }

  return (
    <div className="login-holder">
      <div className="login-content">
        <div className="login-content-headers">
          <h4>Welcome to Banke</h4>
          <div className="login-img">
            <Link to="/">
              <img src={logo} alt="Banke" width={"90px"} height={"45px"} />
            </Link>
          </div>
        </div>
        <div className="login-content-form">
          <div className="mb-3">
            <label htmlFor={"contactEmail"} className="form-label">
              Enter Your Email Address
            </label>
            <input
              type="email"
              name="username"
              value={loginCred.username}
              onChange={handleChange}
              className="form-control"
              id={"contactEmail"}
              placeholder="name@example.com"
            />
          </div>
          <div className="mb-3">
            <label htmlFor={"password"} className="form-label">
              Enter Your Password
            </label>
            <input
              type="password"
              name="password"
              value={loginCred.password}
              onChange={handleChange}
              className="form-control"
              id={"password"}
              placeholder="********"
            />
          </div>
          <p>
            <a
              href="/#"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Forgot password?
            </a>
          </p>
          <div className="mb-3 style-button">
            <button onClick={logUserIn} className="btn btn-primary col-12">
              Login
            </button>
          </div>
        </div>

        {/* LOGGING IN WITH GOOGLE */}
        <div className="mt-3 d-flex justify-content-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => {
              toast.error("Google sign in failed", {
                autoClose: 3000,
              });
            }}
            useOneTap={false}
            theme="outline"
            size="large"
            text="continue_with"
            shape="pill"
          />
        </div>

        <p className="login-footer-text" style={{ textAlign: "center" }}>
          Don’t have an account? <Link to="/auth/register">Sign Up</Link>
        </p>
        <div>
          <img src={loginImage} className="login-image" alt={"..."} />
        </div>
      </div>
      {/* =========================================================================== */}
      {/* RESET PASSWORD */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i
                style={{ cursor: "pointer" }}
                className="fa-solid fa-xmark"
              ></i>
            </p>
            <div>
              <img
                src={logo}
                alt="Banke Store logo"
                width={"15%"}
                height={"10%"}
              />
            </div>
            <div>
              <h4
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  style: "bold",
                  color: "#061D33",
                  fontFamily: "Montserrat",
                }}
              >
                Reset your password
              </h4>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  textAlign: "justify",
                  color: "#7B7B7B",
                }}
              >
                An OTP code will be generated and sent to the inputed mail.
              </p>
            </div>
            <form>
              {/* Reset --- Email */}
              <div className="mb-3">
                <label htmlFor={"resetEmailPassword"} className="form-label">
                  Enter Your Email Address
                </label>
                <input
                  type="email"
                  className="form-control form-control-lg reset-password"
                  id={"resetEmailPassword"}
                  style={{ height: "40px" }}
                  placeholder="youremail@example.com"
                  value={resetPassword}
                  onChange={(e) => setResetPassword(e.target.value)}
                  required
                />
              </div>
              {/* Reset --- OTP */}
              {otpSent ? (
                <>
                  <div className="mb-3">
                    <label
                      htmlFor={"resetEmailPassword"}
                      className="form-label"
                    >
                      Enter your 6-digit OTP
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg reset-password"
                      id={"resetPassword-OTP"}
                      style={{ height: "40px" }}
                      placeholder="123456"
                      value={resetOTP}
                      onChange={(e) => setResetOTP(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor={"resetEmailPassword"}
                      className="form-label"
                    >
                      Enter Your New Password
                    </label>
                    <input
                      type="password"
                      className="form-control form-control-lg reset-password"
                      id={"resetPassword-Password"}
                      style={{ height: "40px" }}
                      value={resetNewPassword}
                      onChange={(e) => setresetNewPassword(e.target.value)}
                      required
                    />
                  </div>
                </>
              ) : null}
            </form>
            <p
              data-bs-dismiss="modal"
              style={{ color: "#1E90FF", fontSize: "11px", cursor: "pointer" }}
            >
              Return to login
            </p>
            <div>
              <button
                type="button"
                className="btn btn-primary col-12"
                onClick={otpSent ? resetUsersPassowrd : confirmEmail}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Confirm Reset password */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i
                style={{ cursor: "pointer" }}
                className="fa-solid fa-xmark"
              ></i>
            </p>
            <div
              style={{ width: "20%", marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={logo} alt="Banke" width={"70px"} height={"40px"} />
            </div>
            <div>
              <h4 style={{ fontSize: "16px" }}>Reset your password</h4>
              <p style={{ fontSize: "12px", textAlign: "center" }}>
                An email has been sent to {"Winnereffiong@gmail.com."} You’ll
                receive instructions on how to set a new password.
              </p>
            </div>
            <div>
              <button type="button" className="btn btn-primary col-12">
                Reset Password
              </button>
            </div>
            <p
              data-bs-dismiss="modal"
              style={{ color: "#1E90FF", fontSize: "11px", cursor: "pointer" }}
            >
              Return to login
            </p>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i
                style={{ cursor: "pointer" }}
                className="fa-solid fa-xmark"
              ></i>
            </p>
            <div
              style={{ width: "20%", marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={logo} alt="Banke" width={"70px"} height={"40px"} />
            </div>
            <div>
              <h4 style={{ fontSize: "16px", textAlign: "center" }}>
                You have successfully created your password
              </h4>
            </div>
            <div>
              <button type="button" className="btn btn-primary col-12">
                Return back to login
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* ------------------------------------ */}
    </div>
  );
};

export default Login;
